import {QueryEntity} from '@datorama/akita';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {MaterialCatalogueItemsState, MaterialCatalogueItemsStore,} from './material-catalogue-items.store';
import {TableColumn} from '../../../models/table-column';
import { IItemsQueryInterface } from 'src/app/core/interfaces/items/items-query.interface';
import { ExpensesCatalogueFilterOptionsModel } from '../../../models/expenses-catalogue/expenses-catalogue-filter-options.model';
import { MaterialCatalogueListItem } from 'src/app/core/models/client-models';

@Injectable({
  providedIn: 'root',
})
export class MaterialCatalogueItemsQuery
  extends QueryEntity<MaterialCatalogueItemsState>
  implements IItemsQueryInterface<MaterialCatalogueListItem>
{
  page$: Observable<number>;
  pageSize$: Observable<number>;
  columns$: Observable<TableColumn[]>;
  lastPage$: Observable<boolean>;
  filterOptions$: Observable<ExpensesCatalogueFilterOptionsModel>;
  filterValue$: Observable<string>;

  constructor(protected store: MaterialCatalogueItemsStore) {
    super(store);
    this.lastPage$ = this.select((state) => state.lastPage);
    this.filterOptions$ = this.select((state) => state.filterOptions);
    this.filterValue$ = this.select((state) => state.filterValue);
    this.page$ = this.select((state) => state.page);
    this.pageSize$ = this.select((state) => state.pageSize);
    this.columns$ = this.select((state) => state.columns);
  }
  getFilterValue(): string {
    throw new Error('Method not implemented.');
  }
  selectFilterValue(): Observable<string> {
    throw new Error('Method not implemented.');
  }

  getActiveText(): string {
    const active = this.getActive();
    return active.number;
  }

  getLoading(): boolean {
    return this.getValue()?.loading;
  }

  getItemText(item: MaterialCatalogueListItem, key: string): string {
    return item.number + ' - ' + item.name;
  }

  getItemValue(item: MaterialCatalogueListItem, key: string) {
    if (key === 'description') {
      return item.name;
    } else {
      return item.number;
    }
  }

  selectTableColumns(): Observable<TableColumn[]> {
    return this.select((state) => state.columns);
  }

  getTableColumns(): TableColumn[] {
    return this.getValue()?.columns;
  }

  selectFilterColumns(): Observable<TableColumn[]> {
    throw 'not implemented';
  }

  getFilterColumns(): TableColumn[] {
    throw 'not implemented';
  }

  selectItems(): Observable<MaterialCatalogueListItem[]> {
    return this.selectAll();
  }

  getItems(): MaterialCatalogueListItem[] {
    return this.getAll();
  }

  selectLastPage(): Observable<boolean> {
    return this.select((state) => state.lastPage);
  }

  getLastPage(): boolean {
    return this.getValue()?.lastPage;
  }

  getRowCssClass(item: MaterialCatalogueListItem): string {
    return '';
  }
}
